import * as React from "react";

const SvgUpYes = ({ color, size }) => (
  <svg
    viewBox="0 0 14 10"
    width={`${14 * (size || 1)}px`}
    height={`${14 * (size || 1)}px`}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.561 2.924H8.807v-2h5v5h-2V4.506L8.51 7.804l-.707.707-.707-.707-2.11-2.11-3.38 3.381L.192 7.661 4.28 3.574l.707-.708.707.708 2.11 2.109 2.758-2.76z"
      fill={color}
    />
  </svg>
);

export default SvgUpYes;
